import { css } from 'styled-components';

export const columns = [
  { name: 'Agency Name', flexSize: 1.5 },
  { name: 'GTFS Static', flexSize: 1 },
  { name: 'RT Vehicle Positions', flexSize: 1 },
  { name: 'RT Trip Updates', flexSize: 1 },
  { name: 'RT Alerts', flexSize: 1 },
];

const basicList = css`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const rowFormat = css`
  ${basicList}
  display: flex;
  align-items: center;
`;

export const columnFormat = css`
  ${basicList}
  padding-left: 10px;
`;
